// the Uniswap Default token list lives here
const NETWORK_CHAIN_ID: number = parseInt(process.env.REACT_APP_CHAIN_ID ?? '1')

console.log('NETWORK_CHAIN_ID', NETWORK_CHAIN_ID)

export const DEFAULT_TOKEN_LIST_URL =
  NETWORK_CHAIN_ID === 168169
    ? 'https://wallet.mud.network/swap/v1/token/list'
    : 'https://wallet.mudtest.net/swap/v1/token/list'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
